module.exports = __webpack_public_path__ + "img/234.f83c248c.jpg";